module.exports = __webpack_public_path__ + "img/c2m_coop1.48ac878c.png";